import React, { useEffect, useState } from "react";
import "../../../css/WeekTransRental.css";
import { fetchAsyncRentalPerDay, RentalPerDay } from "../RentalSlice";
import { handleDate, selectedDate } from "../../weather/WeatherSlice";
import {
  Tooltip,
  XAxis,
  CartesianGrid,
  Legend,
  YAxis,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";

interface WeekTransRentalProps {
  page: number;
  handlePage: (item: number) => void;
}

const WeekTransRental = ({ page, handlePage }: WeekTransRentalProps) => {
  const dispatch = useDispatch();
  const RentalPerDayData = useSelector(RentalPerDay);

  useEffect(() => {
    // 初回描画時に実行する処理
    dispatch(fetchAsyncRentalPerDay(page));

    // 定期実行を設定
    const interval = setInterval(() => {
      dispatch(fetchAsyncRentalPerDay(page));
    }, 60000); // 60秒ごとに実行

    // コンポーネントのクリーンアップ時にインターバルをクリア
    return () => clearInterval(interval);
  }, [dispatch, page]); // 依存配列にdispatchを含める

  //tooltipをカスタムして天気と連動
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload; // payloadからデータを取得

      // 親コンポーネントのstate更新関数を呼び出し
      dispatch(handleDate(data.week));

      return (
        <div className="tooltip">
          <p className="date">{data.week}</p>
          <p className="rental">レンタル件数 : {data.count}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <div
      className="week_rental_trans_container"
      onMouseOut={() => dispatch(handleDate(null))}>
      <div className="week_rental_title_container">
        <div className="back" onClick={() => handlePage(1)}>
          ←
        </div>
        <h2 className="week_rental_trans_title">レンタル件数推移(7日間ごと)</h2>
        <div className="next" onClick={() => handlePage(-1)}>
          →
        </div>
      </div>
      <ResponsiveContainer
        height="75%"
        width="90%"
        minHeight={240}
        minWidth={300}>
        <LineChart data={RentalPerDayData!} className="line_chart">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="week" />
          <YAxis dataKey="count" />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Line
            type="monotone"
            dataKey="count"
            stroke="#82ca9d"
            name="レンタル件数"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WeekTransRental;
